import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface CompletedProductsButtonProps {
  completedCount: number;
  onClick: () => void;
}

export const CompletedProductsButton: React.FC<CompletedProductsButtonProps> = ({ completedCount, onClick }) => {
  if (completedCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 lg:hidden bg-background border-t border-border shadow-lg">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-center space-x-3 bg-green-600 hover:bg-green-700 text-white py-4 transition-colors duration-200 active:bg-green-800"
      >
        <FontAwesomeIcon icon={faCheckCircle} className="w-5 h-5" />
        <span className="text-base font-medium">Ver productos completados</span>
        <div className="bg-green-500 text-white px-2 py-1 rounded-full text-sm font-bold min-w-[24px] text-center">
          {completedCount}
        </div>
      </button>
    </div>
  );
};
